import { global } from "@shared/libs/Global";

export const getConfig = (code: string) => {
  let param: string;
  param = `select dc_ctrl from sys_config where cd_firm = '${
    global.getState().userInfo.cd_firm
  }' and cd_ctrl = '${code}'`;
  return param;
};
